import { render, staticRenderFns } from "./newProd.vue?vue&type=template&id=73a36594&scoped=true"
import script from "./newProd.vue?vue&type=script&lang=js"
export * from "./newProd.vue?vue&type=script&lang=js"
import style0 from "./newProd.vue?vue&type=style&index=0&id=73a36594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a36594",
  null
  
)

export default component.exports